// GraphQL response
export enum NotificationStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    WARNING = 'WARNING',
}

export const NotificationStatusList = [
    NotificationStatusEnum.IN_PROGRESS,
    NotificationStatusEnum.SUCCESS,
    NotificationStatusEnum.ERROR,
    NotificationStatusEnum.WARNING,
];

// Equivalent enum values from BE (WebSocket response)
export const NotificationStatusBEEnum = {
    [NotificationStatusEnum.IN_PROGRESS]: 0,
    [NotificationStatusEnum.SUCCESS]: 1,
    [NotificationStatusEnum.ERROR]: 2,
    [NotificationStatusEnum.WARNING]: 3,
};

// Reverse mapping so that we can convert NotificationStatusBEEnum to NotificationStatusEnum easier
export const BEEnumToNotificationStatus = Object.fromEntries(
    Object.entries(NotificationStatusBEEnum).map(([key, value]) => [value, key]),
) as Record<number, NotificationStatusEnum>;
